import {Link, useLocation, useParams} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import DOMPurify from "dompurify";

const Footer = () => {
    const [menu, setMenu] = useState('');

    useEffect(() => {
        let root = document.getElementById('root');
        fetch( global.config.api + `/?method=header_menu`)
            .then(response => response.json())
            .then(json => {
                if (json) {
                    setMenu(json);
                    // console.log('footer_menu', )
                } else {
                    console.error('Invalid data structure', json);
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [])


    const checkHTML = (string) => {
        return DOMPurify.sanitize(string, { USE_PROFILES: { html: true } });
    }

    return (
        <footer>
            <div className='container'>
                <div className='footer_mail'>
                    <div className='first_row'>
                        <p className='foot_headline'>{menu.subscribe_title}</p>
                        <p className='foot_txt'>{menu.subscribe_subtitle}</p>
                    </div>
                    <div className='second_row'>
                        <form>
                            <input type="email" name="email" id="email" required placeholder="Email"></input>
                            <button type="submit">Подписаться</button>
                        </form>
                    </div>
                </div>
                <div className='footer_line'></div>
                <div className='footer'>
                    <div className='text-col'>
                        <div>
                            <a className='logo'>
                                <img src={menu.site_logo_light} alt="logo"/>
                            </a>
                            <p>{menu.footer_subtitle}</p>
                            <a className='email_link'
                               href={`mailto:${menu.email}`}>{menu.email}</a>
                        </div>
                    </div>
                    <div className='list-col'>
                        <nav>
                            <ul dangerouslySetInnerHTML={{__html: checkHTML(menu.footer_first)}}></ul>
                            <ul dangerouslySetInnerHTML={{__html: checkHTML(menu.footer_second)}}></ul>
                            <ul dangerouslySetInnerHTML={{__html: checkHTML(menu.footer_third)}}></ul>
                        </nav>
                    </div>
                </div>
                <p className='footer_year'>{menu.copyright}</p>
            </div>
        </footer>
    );
};

export default Footer;